
import Layout from '@/views/layout/Layout';

const company = {
  path: '/company',
  component: Layout,
  name: 'companyLayout',
  redirect: '/company/list',
  meta: {
    title: '企业管理',
    isCrumb: true,
    backPage: true
  },
  children: [
    {
      name: 'companyView',
      path: '/company/view',
      component: () => import('@/views/company/companyView.vue'),
      meta: {
        isCrumb: false,
        backPage: false
      },
      children: [
        {
          name: 'companyList',
          path: '/company/list',
          component: () => import('@/views/company/companyList.vue'),
          meta: {
            title: '企业列表',
            isCrumb: true,
            backPage: false,
            isBack: false
          }
        }
      ]
    }

  ]
};

export default company;